export default "__VITE_ASSET__Dt_g5Vhn__"